import { createReducer } from 'utils/redux'

const defaultState = {}
const setLandingPagesSettings = ({ draft, action }) => {
  draft.settings = action.settings
}
const setLandingPagesSubdomain = ({ draft, action }) => {
  draft.subdomain = action.subdomain
}
const setLandingPageIntegrations = ({ draft, action }) => {
  draft.integrations = action.data
}
const setLandingPageCname = ({ draft, action }) => {
  draft.cname = action.data
}

const actions = {
  RECEIVE_LANDING_PAGES: setLandingPagesSettings,
  RECEIVE_LANDING_PAGES_SUBDOMAIN: setLandingPagesSubdomain,
  RECEIVE_LANDING_PAGE_INTEGRATIONS: setLandingPageIntegrations,
  RECIEVE_LANDING_PAGE_CNAME: setLandingPageCname,
  UPDATE_LANDING_PAGES: setLandingPagesSettings,
}

const landingPageReducer = createReducer(defaultState, actions)

export default landingPageReducer
